var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.create(3)}}},[_vm._v(" 新建质量报告 ")])}
var staticRenderFns = []

export { render, staticRenderFns }